import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { CaretRightOutlined,CloseOutlined,RightOutlined,LeftOutlined} from '@ant-design/icons';

import {
  Col,
  Form,
  InputNumber,
  Row,
  Card,
  Button as AntdButton,
  Collapse,
  List,
  Button,
} from 'antd';
import DF from 'DisplayFramework';
import { downloadBlobFile, getURLFile } from 'utils/utils2';

import { getTPCommunication } from 'services/printingService';

import { Page } from 'react-pdf';
import { Document } from 'react-pdf/dist/esm/entry.webpack';
import moment from 'moment';
// import Button from 'components/Button';
import IDownload from 'icons/IDownload';
import Title from 'components/Title';
import { API_URLS } from 'utils/config';

export type CommunicationListProps = {
  tpid?: number;
  onlyCollection?: boolean;
};
const { Panel } = Collapse;

const CommunicationList = ({
  tpid,
  onlyCollection,
}: CommunicationListProps) => {
  const PRINTING_URL = API_URLS.PRINTING;

  const getUrl = (printid: number) =>
    `${PRINTING_URL}/api/print/download?printid=${printid}`;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber,setPageNumber] = useState(1);
  const [scale, setscale] = useState(1);
  const [Params, setParams] = useState<any>({
    isLoading: false,
    objectname: '',
    previewImage: '',
    previewVisibleDOC: false,
    previewTitle: '',
    isPDF: false,
    showAddDocument: false,
    doccode: '',
    doctype: '',
    loadingUpload: false,
    enableUpload: false,
    ok: true,
  });

  const { data } = useQuery(
    ['getTPCommunication', tpid],
    () =>
      getTPCommunication({ tpid: tpid ?? 0 }).then((res) => {
        return res.list || [];
      }),
    { enabled: tpid != null }
  );
  const [url, seturl] = useState('initialState');
  const handlePreviewDOC = (fileurl: any) => {
    let ext = fileurl.substring(fileurl.lastIndexOf('.') + 1);

    setParams({
      previewVisibleDOC: true,
      previewTitle: fileurl.substring(fileurl.lastIndexOf('/') + 1),
      previewImage: fileurl,
      isPDF: ext === 'pdf' ? true : false,
    });
  };

  const handleCancelPreviewDOC = () => setParams({ previewVisibleDOC: false });

  const onChangepdfZoom = (value: any) => {
    setscale(value / 100);
  };
  function onDocumentLoadSuccess({ numPages }: any) {
    setinfo('');
    setNumPages(numPages);
  }

  function changePage(offset: number) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }


  const [info, setinfo] = useState('');
  return (
    <DF.Provider pagcode="doclist">
      <Card size="small">
        <Form>
          <Row>
            <Col span={Params.previewVisibleDOC ? 10 : 24}>
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined
                    style={{ fontSize: 24 }}
                    rotate={isActive ? 90 : 0}
                  />
                )}
                expandIconPosition="left"
                //style={{ marginBottom: 24,overflow:'hidden',backgroundColor:'#f7f7f7',border:0,borderRadius:2  }}
              >
                {!onlyCollection ? (
                  <>
                    <Panel
                      header={<Title level={5} comcode="Proposal"></Title>}
                      key="1"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <List
                        size="small"
                        bordered
                        dataSource={data ?? []}
                        renderItem={(item) => {
                          return (
                            item.docmodule === 'PROPOSAL' && (
                              <List.Item>
                                {'PrintDate: '}
                                <b>
                                  {moment(item.printdate).format('YYYY-MM-DD')}
                                </b>
                                <>
                                  <br />
                                  <AntdButton
                                    onClick={() =>
                                      downloadBlobFile(
                                        item.cireference + '.pdf',
                                        getUrl(item.printid)
                                      )
                                    }
                                    icon={
                                      <IDownload height="14px" width="14px" />
                                    }
                                  />{' '}
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      handlePreviewDOC(item.filename);

                                      getURLFile(
                                        'item.cireference.pdf',
                                        getUrl(item.printid)
                                      ).then((res) => seturl(res));
                                    }}
                                  >
                                    {item.filename}
                                  </a>
                                </>
                              </List.Item>
                            )
                          );
                        }}
                      />
                    </Panel>
                    <Panel
                      header={<Title level={5} comcode="ClientInvoice"></Title>}
                      key="2"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <List
                        size="small"
                        bordered
                        dataSource={data ?? []}
                        renderItem={(item) => {
                          return (
                            item.docmodule === 'CINVOICE' && (
                              <List.Item>
                                {'PrintDate: '}
                                <b>
                                  {moment(item.printdate).format('YYYY-MM-DD')}
                                </b>
                                <>
                                  <br />
                                  <AntdButton
                                    onClick={() =>
                                      downloadBlobFile(
                                        item.cireference + '.pdf',
                                        getUrl(item.printid)
                                      )
                                    }
                                    icon={
                                      <IDownload height="14px" width="14px" />
                                    }
                                  />{' '}
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      handlePreviewDOC(item.filename);

                                      getURLFile(
                                        'item.cireference.pdf',
                                        getUrl(item.printid)
                                      ).then((res) => seturl(res));
                                    }}
                                  >
                                    {item.filename}
                                  </a>
                                </>
                              </List.Item>
                            )
                          );
                        }}
                      />
                    </Panel>
                    <Panel
                      header={<Title level={5} comcode="Payment"></Title>}
                      key="3"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <List
                        size="small"
                        bordered
                        dataSource={data ?? []}
                        renderItem={(item) => {
                          return (
                            item.docmodule === 'PAYMENT' && (
                              <List.Item>
                                {'PrintDate: '}
                                <b>
                                  {moment(item.printdate).format('YYYY-MM-DD')}
                                </b>
                                <>
                                  <br />
                                  <AntdButton
                                    onClick={() =>
                                      downloadBlobFile(
                                        item.cireference + '.pdf',
                                        getUrl(item.printid)
                                      )
                                    }
                                    icon={
                                      <IDownload height="14px" width="14px" />
                                    }
                                  />{' '}
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      handlePreviewDOC(item.filename);

                                      getURLFile(
                                        'item.cireference.pdf',
                                        getUrl(item.printid)
                                      ).then((res) => seturl(res));
                                    }}
                                  >
                                    {item.filename}
                                  </a>
                                </>
                              </List.Item>
                            )
                          );
                        }}
                      />
                    </Panel>
                    <Panel
                      header={<Title level={5} comcode="Contract"></Title>}
                      key="4"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <List
                        size="small"
                        bordered
                        dataSource={data ?? []}
                        renderItem={(item) => {
                          return (
                            item.docmodule === 'CONTRACT' && (
                              <List.Item>
                                {'PrintDate: '}
                                <b>
                                  {moment(item.printdate).format('YYYY-MM-DD')}
                                </b>
                                <>
                                  <br />
                                  <AntdButton
                                    onClick={() =>
                                      downloadBlobFile(
                                        item.cireference + '.pdf',
                                        getUrl(item.printid)
                                      )
                                    }
                                    icon={
                                      <IDownload height="14px" width="14px" />
                                    }
                                  />{' '}
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      handlePreviewDOC(item.filename);

                                      getURLFile(
                                        'item.cireference.pdf',
                                        getUrl(item.printid)
                                      ).then((res) => seturl(res));
                                    }}
                                  >
                                    {item.filename}
                                  </a>
                                </>
                              </List.Item>
                            )
                          );
                        }}
                      />
                    </Panel>
                    <Panel
                      header={<Title level={5} comcode="Collection"></Title>}
                      key="5"
                      style={{
                        marginBottom: 24,
                        overflow: 'hidden',
                        background: '#f7f7f7',
                        border: 10,
                        borderRadius: 2,
                      }}
                    >
                      <List
                        size="small"
                        bordered
                        dataSource={data ?? []}
                        renderItem={(item) => {
                          return (
                            item.docmodule === 'COLLECTION' && (
                              <List.Item>
                                {'PrintDate: '}
                                <b>
                                  {moment(item.printdate).format('YYYY-MM-DD')}
                                </b>
                                <>
                                  <br />
                                  <AntdButton
                                    onClick={() =>
                                      downloadBlobFile(
                                        item.cireference + '.pdf',
                                        getUrl(item.printid)
                                      )
                                    }
                                    icon={
                                      <IDownload height="14px" width="14px" />
                                    }
                                  />{' '}
                                  <a
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      handlePreviewDOC(item.filename);

                                      getURLFile(
                                        'item.cireference.pdf',
                                        getUrl(item.printid)
                                      ).then((res) => seturl(res));
                                    }}
                                  >
                                    {item.filename}
                                  </a>
                                </>
                              </List.Item>
                            )
                          );
                        }}
                      />
                    </Panel>
                  </>
                ) : (
                  <List
                    size="small"
                    bordered
                    dataSource={data ?? []}
                    renderItem={(item) => {
                      return (
                        item.docmodule === 'COLLECTION' && (
                          <List.Item>
                            {'PrintDate: '}
                            <b>{moment(item.printdate).format('YYYY-MM-DD')}</b>
                            <>
                              <br />
                              <AntdButton
                                onClick={() =>
                                  downloadBlobFile(
                                    item.cireference + '.pdf',
                                    getUrl(item.printid)
                                  )
                                }
                                icon={<IDownload height="14px" width="14px" />}
                              />{' '}
                              <a
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  handlePreviewDOC(item.filename);

                                  getURLFile(
                                    'item.cireference.pdf',
                                    getUrl(item.printid)
                                  ).then((res) => seturl(res));
                                }}
                              >
                                {item.filename}
                              </a>
                            </>
                          </List.Item>
                        )
                      );
                    }}
                  />
                )}
              </Collapse>
            </Col>
            {Params.previewVisibleDOC && (
              <Col span={14}>
                <Card>
                  <Row style={{marginLeft:'95%'}}>
                    <AntdButton
                      htmlType="button"
                      icon={
                        <CloseOutlined height="18px" width="18px" />
                      }
                      style={{ color: '#3755ac' }}
                      onClick={handleCancelPreviewDOC}
                    />
                    {/* <Button
                      comcode="closePreview"
                      onClick={handleCancelPreviewDOC}
                    ></Button> */}
                  </Row>
                  <Row>
                    {Params.isPDF && (
                      <div>
                        <Row>
                          <Col>
                            <InputNumber
                              min={10}
                              max={200}
                              formatter={(value) => `${value}%`}
                              step={10}
                              defaultValue={100}
                              onChange={onChangepdfZoom}
                            />
                          </Col>
                        </Row>
                        <h2>{info}</h2>
                        <Button
                          onClick={previousPage} icon={<LeftOutlined />} 
                          style={{color:'#3755ac'}}
                          disabled={numPages ? pageNumber <= 1 : false}
                        />
                        <Button
                          disabled={numPages ?pageNumber >= numPages: false}
                          onClick={nextPage}
                          icon={<RightOutlined />}
                          style={{marginLeft:'85%'}}
                          name='next'
                        />
                        <Document
                          file={url}
                          onLoadSuccess={onDocumentLoadSuccess}
                          onLoadError={() =>
                            setinfo('THERE IS NO PDF FOR THIS PRINTID')
                          }
                        >
                          <Page pageNumber={pageNumber} scale={scale} />
                        </Document>
                        <p>
                          Page {pageNumber} of {numPages}
                        </p>
                      </div>
                    )}

                    {!Params.isPDF && (
                      <iframe
                        title="my_iframe"
                        name="my_iframe"
                        srcDoc={url}
                        width="100%"
                        height="800px"
                        style={{ border: '1px solid #E3E3E3' }}
                      />
                    )}
                  </Row>
                </Card>
              </Col>
            )}
          </Row>
        </Form>
      </Card>
    </DF.Provider>
  );
};

export default CommunicationList;
